import { mapState } from 'pinia'
import { defineAsyncComponent } from 'vue'

import PostStatusForm from 'src/components/post_status_form/post_status_form.vue'
import UserCard from 'src/components/user_card/user_card.vue'

import { useUsersStore } from 'src/stores/users.js'

// only shown to logged-out visitors
const AuthForm = defineAsyncComponent(
  () => import('src/components/auth_form/auth_form.js'),
)

const UserPanel = {
  computed: {
    // /login shows the same form in the main column
    onLoginPage() {
      return this.$route.name === 'login'
    },
    ...mapState(useUsersStore, ['currentUser', 'loggedIn']),
  },
  components: {
    PostStatusForm,
    UserCard,
    AuthForm,
  },
}

export default UserPanel
